import { Tooltip, OverlayTrigger } from "react-bootstrap";
import styles from "./styles-expander.less";
import Slider from "rc-slider/lib";
import classNames from "classnames";

import {
  IncomingIcon,
  OutgoingIcon,
} from "@graphistry/viz/src/components/icons";

const QuickTooltip = ({ message, children, isTop = undefined }) => (
  <OverlayTrigger
    placement={isTop ? "top" : "bottom"}
    overlay={<Tooltip id={message.replace(/\s+/g, "-")}>{message}</Tooltip>}
  >
    {children}
  </OverlayTrigger>
);

function DirectionChooser({ direction, onChange }) {
  const onChangeLocal = (clickedDirection) => {
    if (direction === "none") {
      onChange(clickedDirection);
    } else if (direction === "incoming") {
      onChange(clickedDirection === "outgoing" ? "both" : "none");
    } else if (direction === "outgoing") {
      onChange(clickedDirection === "incoming" ? "both" : "none");
    } else if (direction === "both") {
      onChange(clickedDirection === "incoming" ? "outgoing" : "incoming");
    }
  };

  return (
    <div className={styles.directionChooser}>
      <div className={styles.buttons}>
        <QuickTooltip message="Grow selection on incoming edges">
          <div
            className={classNames(styles.incoming, {
              [styles.active]: direction === "incoming" || direction === "both",
            })}
            onClick={() => onChangeLocal("incoming")}
          >
            <IncomingIcon />
          </div>
        </QuickTooltip>
        <QuickTooltip message="Grow selection on outgoing edges">
          <div
            className={classNames(styles.outgoing, {
              [styles.active]: direction === "outgoing" || direction === "both",
            })}
            onClick={() => onChangeLocal("outgoing")}
          >
            <OutgoingIcon />
          </div>
        </QuickTooltip>
      </div>
      <div className={styles.node}>
        <i className="fa fa-fw fa-circle" />
      </div>
    </div>
  );
}

const MAX_HOPS = 5;
const MIN_HOPS = 1;

const MARKS = [...Array(MAX_HOPS).keys()]
  .map((n) => n + MIN_HOPS)
  .reduce((m, v) => {
    m[v] = v.toString();
    return m;
  }, {}); // { 1: '1', 2: '2', ... }

const ParseHopChange = (next, orig) =>
  Math.max(MIN_HOPS, Math.min(MAX_HOPS, parseInt(next) || orig));

export function Expander({
  hops,
  direction,
  setExpanderHops,
  setExpanderDirection,
  commitExpansion,
  startingPoints,
  startingEdges,
}) {
  return (
    <div className={styles.expander}>
      <DirectionChooser
        direction={direction}
        onChange={(d) => setExpanderDirection({ direction: d })}
      />
      { undefined
      /*
      <input
        type="text"
        className={styles.hopsInput}
        value={hops}
        onChange={({ target: { value: v } }) =>
          setExpanderHops({ hops: ParseHopChange(v, hops) })
        }
      />
      <div className={styles.slider}>
        <Slider
          marks={MARKS}
          min={MIN_HOPS}
          max={MAX_HOPS}
          step={1}
          value={hops}
          onChange={(v) => setExpanderHops({ hops: ParseHopChange(v, hops) })}
        />
      </div>
      */}
      <QuickTooltip message="Expand selection by 1 hop">
        <div
          className={styles.expandButton}
          onClick={() =>
            commitExpansion({ hops, direction, startingPoints, startingEdges })
          }
        >
          <i className="fa fa-fw fa-check" />
        </div>
      </QuickTooltip>
    </div>
  );
}
